angular
	.module 'App.Repository'
	.factory 'UserRoleRepository', ['BaseRepository', (BaseRepository) ->
		class UserRoleRepository extends BaseRepository
			@resource = '/roles'
			@isRestricted = true

		return new UserRoleRepository
	]
